// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼A座326电力"
    },
    0,
    {
      "sub": "机械设计基础",
      "tec": "徐秀玲孙泰鹏",
      "week": "1-12周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "张敏夫",
      "week": "1-17双周",
      "add": "教学楼C座210教务"
    },
    [
      {
        "sub": "数字电子技术基础",
        "tec": "殷文雪",
        "week": "1-8周",
        "add": "实训楼F座201自控"
      },
      {
        "sub": "数字电子技术基础",
        "tec": "殷文雪",
        "week": "9-12周",
        "add": "实训楼F座201自控"
      }
    ]
  ],
  "2": [
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "电子CAD",
      "tec": "侯欣明",
      "week": "9-14周",
      "add": "实训楼F座422自实验室"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-1",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-2",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-4",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-3",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-3",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-1",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "25自机1-5",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      }
    ],
    {
      "sub": "电路（二）",
      "tec": "申爱兵",
      "week": "1-12,15-18周",
      "add": "实训楼F座201自控"
    },
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "1-2,5-6周",
      "add": "教学楼C座210教务"
    }
  ],
  "3": [
    0,
    [
      {
        "sub": "就业创业指导",
        "tec": "杨乘一",
        "week": "1-5周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "马克思主义基本原理",
        "tec": "刘君",
        "week": "6-17周",
        "add": "教学楼C座114教务"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "机械设计基础",
      "tec": "徐秀玲孙泰鹏",
      "week": "1-12周",
      "add": "教学楼C座308教务"
    },
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼B座123自控"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "商晶",
      "week": "1-16周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "张敏夫",
      "week": "1-11,13-17周",
      "add": "教学楼C座212教务"
    },
    {
      "sub": "电路（二）",
      "tec": "申爱兵",
      "week": "1-12,15-18单周",
      "add": "实训楼F座201自控"
    }
  ],
  "5": [
    [
      {
        "sub": "大学英语（三）",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-4",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-3",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "25自机1-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-3",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-1",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-2",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25自机1-5",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      }
    ],
    [
      {
        "sub": "体育（三）",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男羽",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "女篮",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男乒",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "健美操",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "搏击",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男篮",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男网",
        "tec": "郝策",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "男网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男篮"
      },
      {
        "sub": "足球",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男篮"
      }
    ],
    [
      {
        "sub": "数字电子技术基础",
        "tec": "殷文雪",
        "week": "1-8周",
        "add": "实训楼F座201自控"
      },
      {
        "sub": "电子CAD",
        "tec": "侯欣明",
        "week": "9-14周",
        "add": "实训楼F座422自实验室"
      }
    ],
    [
      {
        "sub": "创造性思维与创新方法",
        "tec": "施昭",
        "week": "1-8周",
        "add": "实训楼F座103自控"
      },
      {
        "sub": "数字电子技术基础",
        "tec": "殷文雪",
        "week": "9-12周",
        "add": "实训楼F座201自控"
      }
    ],
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
